import { createSelector } from "reselect"
import { OwnProps as BookmarkButtonProps } from "./components/BookmarkButton"
import { IBookmarkButton, IBookmarks } from "./index"
import { Bookmark } from "../../models"

const getBookmarks = (state: IBookmarks): Record<string, Bookmark> =>
    state.bookmarks

export const getBookmarksArray = createSelector(
    [getBookmarks],
    (bookmarks): Bookmark[] => Object.values(bookmarks),
)

export interface SortedBookmarks {
    sortedBookmarks: Bookmark[]
}

export const getSortedBookmarks = createSelector(
    [getBookmarksArray],
    (bookmarks): SortedBookmarks => ({
        sortedBookmarks: bookmarks.sort((a, b) => a.sequenceNr - b.sequenceNr),
    }),
)

const getFilter = (state: IBookmarks): string => state.filter

export interface FilteredBookmarks {
    filteredBookmarks: Bookmark[]
}

export const getFilteredBookmarksByTitle = createSelector(
    [getSortedBookmarks, getFilter],
    ({ sortedBookmarks }, filter): FilteredBookmarks => ({
        filteredBookmarks: sortedBookmarks.filter((bookmark) =>
            bookmark.title.toLowerCase().includes(filter.toLowerCase()),
        ),
    }),
)

const getBookmarkButtons = (
    state: IBookmarks,
    _props: BookmarkButtonProps,
): Record<string, IBookmarkButton> => state.bookmarkButtons

const getBookmarkButtonId = (
    _state: IBookmarks,
    props: BookmarkButtonProps,
): string => props.bookmarkButtonId

export const getBookmarkButton = createSelector(
    [getBookmarkButtons, getBookmarkButtonId],
    (bookmarkButtons, bookmarkButtonId): IBookmarkButton | null =>
        bookmarkButtons[bookmarkButtonId] ?? null,
)
